/**
 * dog-menu.js
 */

import React from 'react';
import BasicDrawerMenu from 'components/menu-drawer/menu/basic-drawer-menu';
import { ReactComponent as EditIcon } from 'assets/images/edit.svg';
import { ReactComponent as PhotoIcon } from 'assets/images/photo.svg';
import { ReactComponent as VaccinationsIcon } from 'assets/images/hospital.svg';
import { ReactComponent as DocumentsIcon } from 'assets/images/documents.svg';


const DogMenu = ({ dog }) => {
  const items = [
    {
      key: 'details',
      iconName: 'edit',
      label: 'Details',
      isDefaultPage: true,
      path: '/details',
      backgroundImage: <EditIcon />,
    },
    {
      key: 'photo',
      iconName: 'photo',
      label: 'Photo',
      path: '/photo',
      disabled: dog && !dog.id,
      backgroundImage: <PhotoIcon />
    },
    {
      key: 'vaccinations',
      iconName: 'vaccination',
      label: 'Vaccination Summary',
      path: '/vaccinations',
      disabled: dog && !dog.id,
      backgroundImage: <VaccinationsIcon />
    },
    {
      key: 'documents',
      iconName: 'user-guide',
      label: 'Uploaded Documents',
      path: '/docs',
      disabled: dog && !dog.id,
      backgroundImage: <DocumentsIcon />
    }
  ];

  return (
    <BasicDrawerMenu items={items} />
  );
}

export default DogMenu;